import React, { useEffect, useState, useRef } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { Title } from 'react-admin'
import useWindowDimensions from '../useWindowDimensions'
import TabbedView from '../components/TabbedView'
import { modalities } from '../data'
import LogsList from "../modalities-machine-logs/List" 
import MetricsDashboard from '../modalities-metrics-dashboard'

const ModalityDashboard = ({ id }) => {
  const { width } = useWindowDimensions()
  const [modality, setModality] = useState(null)
  const lastFetchedIdRef = useRef(null)

  useEffect(() => {
    // Prevent duplicate fetches - only fetch if id changed or we don't have data
    if (lastFetchedIdRef.current === id && modality) return
    
    lastFetchedIdRef.current = id
    ;(async () => {
      const result = await modalities.fetch(id)
      setModality(result)
    })()
  }, [id])

  return (
    <TabbedView tabLabels={['Metrics', 'Machine Logs']}>
      <Card style={{ backgroundColor: '#fafafa' }}>
        <Title title="Modality Stats" />
        <CardContent style={{ padding: 0 }}>
          <MetricsDashboard modalityId={id} modality={modality} />
        </CardContent>
      </Card>
      <Card style={{ backgroundColor: '#fafafa' }}>
        <CardContent style={{ padding: 0 }}>
          <LogsList
            key={id}
            resource='modalities/logs'
            basePath='/modalities/logs'
            filter={{ modalityId: id }}
            modality={modality}
          />
        </CardContent>
      </Card>
    </TabbedView>
  )
}

export default ModalityDashboard
